import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../../../Layout/Layout";
import DataTable from "react-data-table-component";
import { formatDate, formatDateTime } from "../../../common/Validations";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useSelector
import CustomerConstants from "../../../common/CustomerConstants";
import { addInquiryID } from "../../../redux/feature/customer_app/preSalesSlice";
import ItemService from "../../../services/customer_appCommonService";
import ItemServiceV1 from "../../../services/inventory_appCommonService";
import { SearchField } from "../../../Components/formElements/SearchField";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import MultiColumnFilter from "../../../Components/Filter/MultiColumnFilter";
import StatisticsContainer from "../../../Components/Cards/StatisticsCardContainer";
import WarehouseConstants from "../../../common/WarehouseConstants";
import TableActions from "../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";
import {
  getMaterialIndent,
  getModuleStats,
} from "../../../redux/feature/warehouse_app/warehouseSlice";
import CancelModal from "../../../Components/CancleModal/CancelModal";
import toast from "react-hot-toast";

const IndentListWH = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Pre Sales");
  localStorage.setItem("submenu", "Indent");

  let preSalesData = useSelector((state) => state?.warehouse?.materialIndent); // User Details from Store
  let preSalesTable = useSelector(
    (state) => state?.warehouse?.materialIndent?.pagination,
  ); // User Details from Store
  // eslint-disable-next-line
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  // eslint-disable-next-line
  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);

  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const [filteredData, setFilteredData] = useState([]);
  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);

  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [actionType, setActionType] = useState("Cancel");
  const [getSelectedRows, setSelectedRows] = useState([]);
  const [singleCancelRow, setSingleCancelRow] = useState(null);
  const moduleStats = useSelector((state) => state.warehouse.moduleStats.data);
  const DEFAULT_LIST_PARAMS = {
    queryName: "Get_MaterialIndent_List",
    module: "",
    page: 1,
    per_page: 10,
  };
  const statsPayload = {
    dashboard: "warehouse",
    chartFilterType: "Yearly",
    chartInput2: new Date().getFullYear(),
  };
  const refreshWarehousePage = () => {
    dispatch(getMaterialIndent(DEFAULT_LIST_PARAMS));
    dispatch(getModuleStats(statsPayload));
  };
  useEffect(() => {
    refreshWarehousePage();
    // eslint-disable-next-line
  }, [dispatch]);

  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = (row = null, type = "Cancel") => {
    setActionType(type);
    if (row) {
      setSingleCancelRow(row);
    } else {
      setSingleCancelRow(null);
    }
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
    setSingleCancelRow(null);
    setActionType("Cancel");
  };
  const cancelRows = singleCancelRow ? [singleCancelRow] : getSelectedRows;
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) =>
        item?.statusHeader !== "Cancelled" && item?.statusHeader !== "Deleted",
    );
    setSelectedRows(validRows);
    setSelectedRowIds(validRows.map((item) => String(item.documentNumber)));
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  useEffect(() => {
    if (!showStats) {
      setFilteredData(preSalesData?.data || []);
    }
  }, [showStats, preSalesData]);

  const detailedPage = (inquiryID) => {
    dispatch(addInquiryID(inquiryID));
    navigate(WarehouseConstants.WH_MAT_INDENT_DETAILS);
  };

  const createInquiry = () => {
    navigate(WarehouseConstants.WH_MAT_INDENT_CREATION);
  };

  const handleCancelAPI = async (modalPayload = {}) => {
    try {
      const rows = singleCancelRow ? [singleCancelRow] : getSelectedRows;

      const payload = {
        documentNumber: rows.map((item) => item.documentNumber),
        actionType,
        cancellationRemark: modalPayload?.cancellationRemark || "",
      };

      const res = await ItemServiceV1.cancelOrDeleteMatIndent(payload);

      if (res?.status === 200) {
        toast.success(res?.message || `${actionType} successful`, {
          duration: 3000,
          position: "top-right",
        });

        refreshWarehousePage();
        return res;
      } else {
        toast.error(res?.message || `${actionType} failed. Please try again!`, {
          duration: 4000,
          position: "top-right",
        });
        return res;
      }
    } catch (err) {
      console.error(`${actionType} API Error:`, err);
      toast.error(err?.response?.data?.message || "Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
      return null;
    }
  };
  const columns = [
    {
      name: "Indent Nr",
      id: "documentNumber",
      selector: (row) => row.documentNumber || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.documentNumber)}
        >
          {row.documentNumber || "-"}{" "}
        </button>
      ),
      width: "140px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Created Date",
      selector: (row) => formatDateTime(row.createdAt),
      sortable: true,
      width: "160px",
    },
    {
      name: "Customer Nr",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row.customerCode}</span>
        </>
      ),
      selector: (row) => row.customerCode || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Customer Name",
      id: "customerName",
      dropDown: true,
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row.customerName}</span>
        </>
      ),
      selector: (row) => row.customerName,
      sortable: true,
      width: "200px",
    },
    {
      name: "Status",
      selector: (row) => row.headerStatus,
      id: "headerStatus",
      dropDown: true,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.headerStatus} />
        </>
      ),
      width: "170px",
    },
    {
      name: "Req Delivery Date",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">
            {formatDate(row.reqestDeliveryDate) || "--"}
          </span>
        </>
      ),
      selector: (row) => row.reqestDeliveryDate,
      sortable: true,
      width: "180px",
    },
    {
      name: "PaymentTerms",
      cell: (row) => (
        <>
          <span> {row.paymentTerms} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Company",
      cell: (row) => (
        <>
          <span> {row.companyCode} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Sales Org",
      cell: (row) => (
        <>
          <span> {row.salesOrg} </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Distribution Channel",
      cell: (row) => (
        <>
          <span> {row.disrtibutionChannel} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Division",
      cell: (row) => (
        <>
          <span> {row.division} </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Reason",
      selector: (row) => row.inquiryRemark,
      sortable: true,
      width: "200px",
    },
    {
      name: "Initiator",
      selector: (row) => row.initiator || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "SAP Inquiry Nr",
      selector: (row) => row.sapInquiryNr || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "SAP Remark",
      selector: (row) => row.rfqTechTargetDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Action",
      cell: (row) => {
        const status = row?.headerStatus;

        const isCancelled = status === "Cancelled";
        const isDeleted = status === "Deleted";

        return (
          <TableActions
            selectedRow={selectedRowIds.includes(String(row.documentNumber))}
            actions={[
              {
                key: "details",
                label: "Details",
                icon: "bi bi-info-circle",
              },
              {
                key: "edit",
                label: "Edit",
                icon: "bi bi-pencil-square",
                onClick: () => detailedPage(row.documentNumber),
                disabled: isDeleted,
              },
              {
                key: "cancel",
                label: "Cancel",
                icon: "bi bi-x-circle",
                onClick: () => cancelModalShow(row, "Cancel"),
                selectRow: true,
                disabled: isCancelled || isDeleted,
              },
              {
                key: "delete",
                label: "Delete",
                icon: "bi bi-trash",
                onClick: () => cancelModalShow(row, "Delete"),
                selectRow: true,
                disabled: isDeleted,
              },
              {
                key: "more",
                label: "More",
                icon: "bi bi-three-dots",
                onClick: () => console.log("More", row),
              },
            ]}
          />
        );
      },
      width: "180px",
    },
  ];
  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "Get_MaterialIndent_List",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getMaterialIndent(obj));
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));

  const loadInitialSuuplierData = async () => {
    setData(preSalesData?.data);
  };

  const lineItemColInfo = [
    {
      name: "Item Nr",
      cell: (row) => <span>{row.inquiryDocumentItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.inquiryQuantity} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "220px",
    },
  ];

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_MaterialIndent_List",
      module: "CUSTOMER",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getMaterialIndent(obj));
    setData(preSalesData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_MaterialIndent_List",
      module: "CUSTOMER",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getMaterialIndent(obj));
    setData(preSalesData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_MaterialIndent_List",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getMaterialIndent(obj));
  };

  useEffect(() => {
    loadInitialSuuplierData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preSalesData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Get_MaterialIndent_List",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getMaterialIndent(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Indent List</h2>
                <p className="subText">Indent Details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>

            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                // data={data}
                fetchFunction={ItemService.generateCustomerQuery}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
                queryName="Get_MaterialIndent_List"
              />
            )}
            <hr />
            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>
                <StatisticsContainer
                  statsMode="redux"
                  reduxStats={moduleStats}
                  reduxKey="MaterialIndent"
                  keyName="headerStatus"
                  paginatedList={preSalesData?.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                />
              </div>
            )}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IL</span>
                    </Col>
                    <Col xs={1} md={8} lg={8}>
                      <span className="headerTitle">Indent List</span>
                      <span className="subHeaderTitle">
                        View of Indent and Status{" "}
                      </span>
                    </Col>
                    {/* commented for poc */}
                    {/* {userData?.category === "CUSTOMER" && ( */}
                    <Col xs={1} md={2} lg={2} className="">
                      <button className="btnTable" onClick={createInquiry}>
                        <i className="bi bi-cart-check"></i> Create Indent
                      </button>
                    </Col>
                    {/* )} */}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // data={data}
                          data={filteredData}
                          progressPending={preSalesData?.status}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationTotalRows={preSalesTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <CancelModal
        title={
          actionType === "Delete" ? "Delete the Stock" : "Cancel the Stock"
        }
        type="Indent"
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={cancelRows}
        onConfirm={handleCancelAPI}
        docKey="documentNumber"
        onSuccess={() => {
          setSelectedRows([]);
          setSelectedRowIds([]);
          setSingleCancelRow(null);
          setActionType("Cancel");
          refreshWarehousePage();
        }}
      />
    </main>
  );
};

export default IndentListWH;
